var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { filterCTAButtons, getFetchOptions, removePhoneButton, searchForPhoneButton, validateEmail, } from './ButtonUtills';
import { useServicesContext } from '../../context';
import { getFinanceDataFromStore } from '../../utils/leanCheckoutUtils';
export const useButtons = (vehicle, appContext, selectedModality, useFinanceData, configurationService, environmentConfig, showAsText, isTilesButtonMode) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const servicesContext = useServicesContext();
    const audiContentService = servicesContext.getAdditionalService('audi-content-service');
    let rawCTAButtons = [];
    let configuration;
    if (appContext === 'pdp') {
        configuration = (_c = (_b = (_a = audiContentService.getContent()) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.vtpConfiguration) === null || _c === void 0 ? void 0 : _c.fields;
        rawCTAButtons = (_e = (_d = configuration.cta) === null || _d === void 0 ? void 0 : _d.map((button) => button.fields)) !== null && _e !== void 0 ? _e : [];
    }
    else {
        configuration = configurationService === null || configurationService === void 0 ? void 0 : configurationService.getConfiguration();
        rawCTAButtons = (_f = configuration.cta) !== null && _f !== void 0 ? _f : [];
    }
    const scContextId = (configuration === null || configuration === void 0 ? void 0 : configuration.scContextId)
        ? configuration === null || configuration === void 0 ? void 0 : configuration.scContextId
        : undefined;
    const [ctaLiteReservationButton, setCtaLiteReservationButton] = React.useState(undefined);
    const ForcePhoneAsPrimary = ((_g = configuration === null || configuration === void 0 ? void 0 : configuration.scopes) === null || _g === void 0 ? void 0 : _g.forcePhoneAsPrimary)
        ? configuration === null || configuration === void 0 ? void 0 : configuration.scopes.forcePhoneAsPrimary
        : false;
    const phoneWithNumber = ((_h = configuration === null || configuration === void 0 ? void 0 : configuration.scopes) === null || _h === void 0 ? void 0 : _h.phoneWithNumber)
        ? configuration === null || configuration === void 0 ? void 0 : configuration.scopes.phoneWithNumber
        : false;
    const liteReservationButton = rawCTAButtons.find((button) => button.type === 'liteReservation');
    const checkDisplayOption = (liteReservationButton === null || liteReservationButton === void 0 ? void 0 : liteReservationButton.displayOption) === appContext ||
        (liteReservationButton === null || liteReservationButton === void 0 ? void 0 : liteReservationButton.displayOption) === 'both';
    const financeData = getFinanceDataFromStore(vehicle);
    const CTAButtons = filterCTAButtons(rawCTAButtons, vehicle, appContext, selectedModality, useFinanceData, showAsText, isTilesButtonMode, ctaLiteReservationButton, financeData);
    const [initialButtonsState, setinitialButtonsState] = React.useState(CTAButtons);
    const [buttonsState, setButtonsState] = React.useState(CTAButtons);
    const [isDesktop, setIsDesktop] = React.useState(false);
    const PhoneCTA = searchForPhoneButton(CTAButtons, appContext);
    const liteReservationButtonUrl = (_j = liteReservationButton === null || liteReservationButton === void 0 ? void 0 : liteReservationButton.url) !== null && _j !== void 0 ? _j : undefined;
    const fetchOptions = liteReservationButtonUrl
        ? getFetchOptions(environmentConfig, vehicle, liteReservationButton)
        : undefined;
    const showLiteReservedVehicle = validateEmail((_k = vehicle.dealer) === null || _k === void 0 ? void 0 : _k.email) &&
        typeof window !== 'undefined' &&
        environmentConfig.pdfBaseURL;
    useEffect(() => {
        if (checkDisplayOption) {
            const fetchLiteReservationUrl = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const response = yield fetch(liteReservationButtonUrl, fetchOptions);
                    if (response.status === 201 || response.status === 200) {
                        const liteReservationUrl = yield response.text();
                        if (liteReservationUrl && liteReservationUrl.length > 0) {
                            const ctaLiteReservation = {
                                method: 'GET',
                                type: 'liteReservation',
                                url: liteReservationUrl,
                                target: 'new-window',
                                label: liteReservationButton.label,
                                displayOption: liteReservationButton.displayOption,
                                reservation: liteReservationButton.reservation,
                                buyableOnline: 'ignored',
                            };
                            let liteReservationFilteredButtons = filterCTAButtons(rawCTAButtons, vehicle, appContext, selectedModality, useFinanceData, showAsText, isTilesButtonMode, ctaLiteReservation, financeData);
                            if (appContext === 'carinfo' && window.matchMedia('(min-width: 480px)').matches) {
                                liteReservationFilteredButtons = removePhoneButton(liteReservationFilteredButtons);
                            }
                            setButtonsState(liteReservationFilteredButtons);
                            setinitialButtonsState(liteReservationFilteredButtons);
                            setCtaLiteReservationButton(ctaLiteReservation);
                        }
                    }
                }
                catch (_a) {
                    console.error('error while fetching lite reservation url');
                }
            });
            if (showLiteReservedVehicle && liteReservationButton) {
                fetchLiteReservationUrl();
            }
        }
        return () => { };
    }, [liteReservationButton]);
    const setDeviceType = () => {
        if (!window.matchMedia('(min-width: 480px)').matches) {
            setIsDesktop(false);
        }
        else {
            setIsDesktop(true);
        }
    };
    const handlePhoneButton = () => {
        if (!window.matchMedia('(min-width: 480px)').matches) {
            if (ForcePhoneAsPrimary &&
                (appContext === 'carinfo' || (!isTilesButtonMode && showAsText) || isTilesButtonMode)) {
                const buttonsWithoutPhone = removePhoneButton(buttonsState);
                setButtonsState([PhoneCTA, ...buttonsWithoutPhone]);
            }
            else {
                setButtonsState(initialButtonsState);
            }
        }
        else {
            const buttonsWithoutPhone = removePhoneButton(buttonsState);
            if (appContext === 'carinfo') {
                setButtonsState(buttonsWithoutPhone);
            }
            else {
                setButtonsState(initialButtonsState);
            }
        }
    };
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            setDeviceType();
            window.addEventListener('resize', setDeviceType);
            if (PhoneCTA) {
                handlePhoneButton();
                window.addEventListener('resize', handlePhoneButton);
                return () => {
                    window.removeEventListener('resize', handlePhoneButton);
                    window.removeEventListener('resize', setDeviceType);
                };
            }
            return () => {
                window.removeEventListener('resize', setDeviceType);
            };
        }
        return undefined;
    }, []);
    return {
        financeButtonsState: CTAButtons,
        isDesktop,
        buttonsState,
        scContextId,
        phoneWithNumber,
    };
};
